import { render, staticRenderFns } from "./AnnouncementsGrid.vue?vue&type=template&id=f02ae726"
import script from "./AnnouncementsGrid.vue?vue&type=script&lang=js"
export * from "./AnnouncementsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports